export interface HtmlPage {
  id: string;
  name: string;
  description?: string;
  slug: string;
  html: string;
  javascript: string;
  css?: string;
  type?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface HtmlPageFormData {
  name: string;
  description?: string;
  slug: string;
  html: string;
  javascript: string;
  css?: string;
  type?: string;
  isActive: boolean;
}

export const HTML_WIDGET_PREFIX = "html_widget_";
export const CALCULATOR_PREFIX = "calculator_";
export const LANDING_PAGE_PREFIX = "landing_page_";

export interface HtmlPageFilters {
  type?: string;
  isActive?: boolean;
  search?: string;
}

// Type choices removed - users can freely enter any type they want